import { Component } from 'vue'
import { ModalEvent, ModalState } from './enums'
import { addEventListener, callEvent, removeEventListener } from './helpers'
import { OVERLAY_DURATION } from '@/const'

export type ModalEventCallback = (...props: any) => any
export type ModalEvents = {
  [key in ModalEvent]?: ModalEventCallback[]
}
export type ModalProps = Record<string, any>

export class ModalEntity {
  private component: Component

  constructor(component: Component) {
    this.component = component
  }

  get getModal() {
    return this.component
  }
}

export class ModalClass<T> {
  state: ModalState = ModalState.CLOSED
  zIndex = 0
  props: ModalProps | undefined
  entity: T
  allowTray: boolean

  protected events: ModalEvents = {}

  constructor(entity: T, allowTray = false) {
    this.entity = entity
    this.allowTray = allowTray
  }

  protected callEvent(name: ModalEvent) {
    callEvent(this.events, name)
  }

  addEventListener(name: ModalEvent, callback: ModalEventCallback) {
    addEventListener(this.events, name, callback)
  }

  removeEventListener(name: ModalEvent, callback: ModalEventCallback) {
    removeEventListener(this.events, name, callback)
  }

  get isOpened() {
    return ![ModalState.CLOSED, ModalState.CLOSING, ModalState.HIDDEN, ModalState.HIDING].includes(this.state)
  }

  get isMinimized() {
    return this.state === ModalState.HIDDEN
  }

  open(zIndex: number, props?: ModalProps) {
    this.zIndex = zIndex
    this.props = props
    this.state = ModalState.OPENING
    setTimeout(() => {
      this.state = ModalState.OPENED
      this.callEvent(ModalEvent.OPEN)
    }, OVERLAY_DURATION)
  }

  close() {
    this.state = ModalState.CLOSING
    setTimeout(() => {
      this.state = ModalState.CLOSED
      this.callEvent(ModalEvent.CLOSE)
    }, OVERLAY_DURATION)
  }

  forceClose() {
    this.state = ModalState.CLOSED
    this.callEvent(ModalEvent.CLOSE)
  }

  conditionalClose(force = false) {
    if (force) {
      this.forceClose()
    } else {
      this.close()
    }
  }

  hide() {
    this.state = ModalState.HIDING
    setTimeout(() => {
      this.state = ModalState.HIDDEN
      this.callEvent(ModalEvent.HIDE)
    }, OVERLAY_DURATION)
  }

  show(zIndex: number) {
    this.zIndex = zIndex
    this.state = ModalState.OPENING
    setTimeout(() => {
      this.state = ModalState.OPENED
      this.callEvent(ModalEvent.SHOW)
    }, OVERLAY_DURATION)
  }
}
